import { useSession } from "./useSession";

export const useStates = () => {
  const { read, update } = useSession();

  const states = {
    BUSY: -1,

    CHECK_EXT_PARAMS_START: 10,
    CHECK_EXT_PARAMS_END: 20,

    GEOLOCALIZE_START: 30,
    GEOLOCALIZE_END: 40,

    FETCH_POSITION_START: 50,
    FETCH_POSITION_ERROR: 55,
    FETCH_POSITION_END: 60,

    FETCH_FILIALI_START: 70,
    FETCH_FILIALI_WAITING: 75,
    FETCH_FILIALI_END: 80,

    LOAD_FILIALI_SLIDES_START: 90,
    LOAD_FILIALI_SLIDES_END: 100,

    FETCH_CF_START: 110,
    FETCH_CF_ERROR: 120,
    FETCH_CF_EDIT_APPOINTMENT: 130,
    FETCH_CF_END: 140,

    CREA_APPUNTAMENTO_START: 170,
    CREA_APPUNTAMENTO_ERROR: 180,
    CREA_APPUNTAMENTO_END: 1,
  };

  const isGeolocalizeStart = () => {
    return read("state") >= states.GEOLOCALIZE_START;
  };
  const isGeolocalizeEnd = () => {
    return read("state") >= states.GEOLOCALIZE_END;
  };
  const isFetchPositioStart = () => {
    return read("state") == states.FETCH_POSITION_START;
  };
  const isFetchPositioEnd = () => {
    return read("state") >= states.FETCH_POSITION_END;
  };
  const isFetchFilialiWaiting = () => {
    return read("state") == states.FETCH_FILIALI_WAITING;
  };
  const isFetchFilialiStart = () => {
    return read("state") >= states.FETCH_FILIALI_START;
  };

  const isFilialiSlideBusy = () => {
    return read("state") == states.LOAD_FILIALI_SLIDES_START;
  };

  const isCfFetchStart = () => {
    return read("state") == states.FETCH_CF_START;
  };
  const isCfFetchError = () => {
    return read("state") == states.FETCH_CF_ERROR;
  };
  const isCfEditAppointment = () => {
    return read("state") == states.FETCH_CF_EDIT_APPOINTMENT;
  };

  const isCreaAppuntamentoBusy = () => {
    return read("state") == states.CREA_APPUNTAMENTO_START;
  };
  const isCreaAppuntamentoError = () => {
    return read("state") == states.CREA_APPUNTAMENTO_ERROR;
  };
  const isCreaAppuntamentoDone = () => {
    return read("state") == states.CREA_APPUNTAMENTO_END;
  };

  const isLuogoPageReady = () => {
    return read("state") >= states.CHECK_EXT_PARAMS_END;
  };
  const isFilialiPageReady = () => {
    return read("state") >= states.FETCH_FILIALI_END;
  };
  const isFilialiDirectPageReady = () => {
    return read("state") >= states.FETCH_FILIALI_END;
  };
  const isCfPageReady = () => {
    return read("state") >= states.LOAD_FILIALI_SLIDES_END;
  };
  const isDatiUtenteReady = () => {
    return read("state") >= states.FETCH_CF_END;

  };
  const isRiepilogoPageReady = () => {
    return read("state") == states.CREA_APPUNTAMENTO_END;
  };

  const setCurrentState = (newState) => {
    update("state", newState);
  };

  return {
    states,
    isLuogoPageReady,
    isFilialiPageReady,
    isFilialiDirectPageReady,
    isCfPageReady,
    setCurrentState,
    isGeolocalizeStart,
    isGeolocalizeEnd,
    isFetchPositioStart,
    isFetchPositioEnd,
    isFetchFilialiStart,
    isFetchFilialiWaiting,
    isFilialiSlideBusy,
    isDatiUtenteReady,
    isCfFetchStart,
    isCfFetchError,
    isCfEditAppointment,
    isRiepilogoPageReady,
    isCreaAppuntamentoBusy,
    isCreaAppuntamentoError,
    isCreaAppuntamentoDone,
  };
};
